
        import 'ClaimDetails.d96d272.css-module'
        export default {"claimsCostTable":"claimsCostTable_ClaimDetails_d96d272","QnA":"QnA_ClaimDetails_d96d272"}
    